import { colors } from 'constants/colors';

export const shadows = {
  boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05), 0 2px 6px 0 rgba(0, 0, 0, 0.05), 0 0 4px 0 rgba(0, 0, 0, 0.05)',
  dropShadow: '0 8px 16px rgba(0, 75, 70, 0.04), 0 0 6px rgba(0, 0, 0, 0.04)',
  stickyHeader: `0 1px 0 0 ${colors.paleGrey}`,
};
